<template>
    <div>
        <head-layout :title="productGroup.name" />

        <breadcrumbs :items="breadcrumbs" />

        <div class="row my-4">
            <div class="col">
                <product-search />
            </div>
        </div>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-row>
                        <v-col cols="12" sm="9">
                            <v-card-title
                                class="text-h3 primary--text"
                                v-text="productGroup.name"
                            />

                            <v-card-text
                                class="mt-2"
                                :class="{
                                    'primary--text': productGroup.golden,
                                }"
                                v-text="productGroup.description"
                            />
                        </v-col>
                        <v-col
                            v-if="productGroup.icon_url"
                            cols="6"
                            offset="3"
                            offset-sm="0"
                            sm="3"
                            class="d-flex"
                        >
                            <v-card-text class="mt-auto">
                                <v-img
                                    eager
                                    :src="productGroup.icon_url"
                                    width="100%"
                                    aspect-ratio="1.3"
                                    contain
                                    max-height="100px"
                                    pos
                                />
                            </v-card-text>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>

        <gallery-grid
            :items="productGroup.products"
            :route-function="
                (item) =>
                    route('catalogue.product', {
                        department: $page.props.department.slug,
                        productGroup: productGroup.slug,
                        product: item.slug,
                    })
            "
        >
            <template v-slot:subtitle="{ item }">
                <rental-rates :item="item" />
            </template>
        </gallery-grid>

        <how-to-hire />
    </div>
</template>

<script>
import GalleryGrid from "@/Components/Catalogue/GalleryGrid";
import Breadcrumbs from "@/Components/Catalogue/Breadcrumbs";
import HeadLayout from "@/Layouts/HeadLayout";
import RentalRates from "@/Components/Catalogue/RentalRates";
import HowToHire from "@/Components/Catalogue/HowToHire";
import ProductSearch from "@/Components/Catalogue/ProductSearch";

export default {
    name: "ProductGroup",
    components: {
        ProductSearch,
        HowToHire,
        RentalRates,
        HeadLayout,
        Breadcrumbs,
        GalleryGrid,
    },
    props: {
        productGroup: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            breadcrumbs: [
                {
                    text: "Hire Catalogue",
                    disabled: false,
                    href: "/",
                },
                {
                    text: this.$page.props.department.name,
                    disabled: false,
                    href: this.route(
                        "catalogue.department",
                        this.$page.props.department.slug
                    ),
                },
                {
                    text: this.productGroup.name,
                    disabled: true,
                    href: this.route("catalogue.productGroup", [
                        this.$page.props.department.slug,
                        this.productGroup.slug,
                    ]),
                },
            ],
        };
    },
};
</script>

<style scoped></style>
